(function () {
  const viewers = document.querySelectorAll("[data-viewer-360]");

  viewers.forEach((viewer) => {
    initViewer(viewer);
  });

  function initViewer(viewer) {
    // Elements
    const slider = viewer.querySelector("[data-viewer-slider]");
    const images = viewer.querySelectorAll("[data-viewer-image]");
    const handle = viewer.querySelector("[data-viewer-handle]");
    const tickPath = viewer.querySelector("[data-viewer-lines]");
    const track = viewer.querySelector(".viewer-360__track");
    const config = JSON.parse(
      viewer.querySelector("[data-viewer-config]").textContent,
    );

    // Configuration
    const imageCount = config.imageCount;

    // Single image — nothing to rotate, skip interactive setup
    if (imageCount <= 1 || !slider || !handle || !track) return;
    const CURVE_DEPTH_RATIO = 0.6;
    const GRADIENT_DARK_SPREAD = 15;
    const GRADIENT_LIGHT_SPREAD = 35;
    const ANIMATION_DURATION = 1000;
    const BEZIER_START_X = 5;
    const BEZIER_END_X = 346;
    const BEZIER_ANCHOR_Y = 50;

    // State
    let currentIndex = parseInt(slider.value);
    let loadedImages = new Set([0, 1, 2]);
    let preloadTimeout = null;
    let previousIndex = currentIndex;
    let isDragging = false;
    let hasAnimated = false;

    function calculateCubicBezierPoint(t, p0, p1, p2, p3) {
      const mt = 1 - t;
      const mt2 = mt * mt;
      const mt3 = mt2 * mt;
      const t2 = t * t;
      const t3 = t2 * t;

      return {
        x: mt3 * p0.x + 3 * mt2 * t * p1.x + 3 * mt * t2 * p2.x + t3 * p3.x,
        y: mt3 * p0.y + 3 * mt2 * t * p1.y + 3 * mt * t2 * p2.y + t3 * p3.y,
      };
    }

    // Calculate handle position from slider value using bezier curve
    function calculatePosition(value) {
      const normalized = imageCount > 1 ? value / (imageCount - 1) : 0;
      const t = normalized;

      // Bezier curve control points adjusted for handle alignment and size
      const p0 = { x: BEZIER_START_X, y: BEZIER_ANCHOR_Y };
      const p1 = { x: 100, y: BEZIER_ANCHOR_Y + 50 * CURVE_DEPTH_RATIO };
      const p2 = { x: 300, y: BEZIER_ANCHOR_Y + 50 * CURVE_DEPTH_RATIO };
      const p3 = { x: BEZIER_END_X, y: BEZIER_ANCHOR_Y };

      const svgPoint = calculateCubicBezierPoint(t, p0, p1, p2, p3);

      const rect = track.getBoundingClientRect();

      // Get the actual SVG to read its viewBox
      const svg = track.querySelector(".viewer-360__svg");
      if (!svg) {
        console.warn("SVG element not found");
        return { x: 0, y: 0, angle: 0 };
      }

      const viewBox = svg.getAttribute("viewBox").split(" ");
      const viewBoxWidth = parseFloat(viewBox[2]);
      const viewBoxHeight = parseFloat(viewBox[3]);

      const scaleX = rect.width / viewBoxWidth;
      const scaleY = rect.height / viewBoxHeight;

      return {
        x: svgPoint.x * scaleX,
        y: svgPoint.y * scaleY,
        angle: 0,
      };
    }

    // Update handle position
    function updateHandle(value) {
      const pos = calculatePosition(value);
      handle.style.left = `${pos.x}px`;
      handle.style.top = `${pos.y}px`;
    }

    // Update tick path animation based on handle position
    function updateTicks(value) {
      if (!tickPath) return;

      const normalized = imageCount > 1 ? value / (imageCount - 1) : 0;
      const pathLength = tickPath.getTotalLength();
      const offset = normalized * pathLength;

      tickPath.style.strokeDashoffset = -offset;

      // Update gradient to be darker near handle position
      const gradientId = tickPath
        .getAttribute("stroke")
        .match(/url\(#([^)]+)\)/)?.[1];

      if (!gradientId) return;

      const gradient = viewer.querySelector(`#${gradientId}`);
      if (!gradient) return;

      const stops = gradient.querySelectorAll("stop");
      if (stops.length < 4) return;

      const centerPos = normalized * 100;

      stops[0].setAttribute(
        "offset",
        `${Math.max(0, centerPos - GRADIENT_LIGHT_SPREAD)}%`,
      );
      stops[1].setAttribute(
        "offset",
        `${Math.max(0, centerPos - GRADIENT_DARK_SPREAD)}%`,
      );
      stops[2].setAttribute(
        "offset",
        `${Math.min(100, centerPos + GRADIENT_DARK_SPREAD)}%`,
      );
      stops[3].setAttribute(
        "offset",
        `${Math.min(100, centerPos + GRADIENT_LIGHT_SPREAD)}%`,
      );
    }

    // Load image
    function loadImage(index) {
      if (index < 0 || index >= imageCount) return;
      if (loadedImages.has(index)) return;

      const img = images[index];
      const dataSrc = img.getAttribute("data-src");

      if (dataSrc) {
        const preloader = new Image();
        preloader.onload = () => {
          img.src = dataSrc;
          img.removeAttribute("data-src");
          loadedImages.add(index);
        };
        preloader.src = dataSrc;
      }
    }

    // Preload surrounding images
    function preloadSurroundingImages(index) {
      if (preloadTimeout) clearTimeout(preloadTimeout);

      loadImage(index - 1);
      loadImage(index + 1);

      preloadTimeout = setTimeout(() => {
        for (let i = -5; i <= 5; i++) {
          loadImage(index + i);
        }
      }, 50);
    }

    // Update active image with crossfade
    function updateImage(index) {
      if (index === previousIndex) return;

      const isLoaded = loadedImages.has(index);

      if (isLoaded) {
        images[index].classList.add("is-active");
        images[index].classList.remove("is-fading-out");

        if (previousIndex !== index) {
          images[previousIndex].classList.remove("is-active");
          images[previousIndex].classList.add("is-fading-out");

          setTimeout(() => {
            images[previousIndex].classList.remove("is-fading-out");
          }, 100);
        }

        previousIndex = index;
      } else {
        loadImage(index);
      }

      preloadSurroundingImages(index);
    }

    // Handle slider changes (also triggered by drag)
    slider.addEventListener("input", (e) => {
      const newIndex = parseInt(e.target.value);
      updateImage(newIndex);
      updateHandle(newIndex);
      updateTicks(newIndex);
    });

    // Handle dragging
    handle.addEventListener("mousedown", startDrag);
    handle.addEventListener("touchstart", startDrag, { passive: false });

    function startDrag(e) {
      isDragging = true;
      handle.classList.add("is-dragging");
      e.preventDefault();
    }

    document.addEventListener("mousemove", onDrag);
    document.addEventListener("touchmove", onDrag, { passive: false });

    function onDrag(e) {
      if (!isDragging) return;

      const clientX = e.type.includes("touch")
        ? e.touches[0].clientX
        : e.clientX;

      const rect = track.getBoundingClientRect();

      // Get X position relative to track and convert to 0-1 range
      const relativeX = clientX - rect.left;
      const normalized = Math.max(0, Math.min(1, relativeX / rect.width));

      // Convert to slider value
      const value = Math.round(normalized * (imageCount - 1));

      slider.value = value;
      slider.dispatchEvent(new Event("input"));
    }

    document.addEventListener("mouseup", endDrag);
    document.addEventListener("touchend", endDrag);

    function endDrag() {
      isDragging = false;
      handle.classList.remove("is-dragging");
    }

    // Animate from start position to frame 0 (steering wheel on right)
    function animateToPosition(startIndex) {
      if (hasAnimated) return;

      const startTime = Date.now();
      const targetIndex = 0;

      function animate() {
        const elapsed = Date.now() - startTime;
        const progress = Math.min(elapsed / ANIMATION_DURATION, 1);

        // Easing function (ease-in-out)
        const eased =
          progress < 0.5
            ? 2 * progress * progress
            : 1 - Math.pow(-2 * progress + 2, 2) / 2;

        const currentValue = Math.round(
          startIndex + (targetIndex - startIndex) * eased,
        );

        slider.value = currentValue;
        updateImage(currentValue);
        updateHandle(currentValue);
        updateTicks(currentValue);

        if (progress < 1) {
          animationFrame = requestAnimationFrame(animate);
        } else {
          hasAnimated = true;
        }
      }

      animate();
    }

    // Get start index from config (for animation starting point)
    const startIndex = config.startAngle
      ? Math.round((config.startAngle / 360) * (imageCount - 1))
      : 0;

    // Intersection Observer to trigger animation when in view
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated) {
            observer.unobserve(viewer);
            animateToPosition(startIndex);
          }
        });
      },
      { threshold: 0.3 },
    );

    observer.observe(viewer);

    // Initialize at start position (animation will move to frame 0)
    currentIndex = startIndex;
    slider.value = startIndex;
    if (startIndex !== 0) {
      images[0].classList.remove("is-active");
      loadImage(startIndex);
    }
    images[startIndex].classList.add("is-active");
    updateHandle(startIndex);
    updateTicks(startIndex);
    preloadSurroundingImages(startIndex);
  }
})();
